"use strict";
angular.module("internal.exams", ['ngAnimate', 'ui.bootstrap']).config([
    "$stateProvider",
    "$urlRouterProvider",
    function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("internal.exams", {
                abstract: true,
                templateUrl: paths.app + "/layouts/exams.html"
            }).state("internal.exams.exam", {
                url: "/exams",
                templateUrl: paths.app + "exams/components/exams/exams.html",
                controller: "InternalExams",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", "$scope", function ($state, $rootScope, Permissions, $scope) {
                        $scope.state = $state;
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.exam").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            })

            // Exam Sessions Tab 
            .state("internal.exams.session", {
                abstract: true,
                templateUrl: paths.app + "exams/layouts/session.html",
                controller: "InternalExamSession",
                params: {
                    examSessionID: null
                }
            }).state("internal.exams.sessions", {
                url: "/exams/sessions/list",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-sessions-list/exam-sessions-list.html",
                controller: "InternalExamSessionsList",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.sessions").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.details", {
                url: "/exams/sessions/details/:examSessionID",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-session-details/exam-session-details.html",
                controller: "InternalExamSessionDetails",
                params: {
                    examSessionID: 'create'
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.stations", {
                url: "/exams/sessions/details/:examSessionID/stations",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-session-details/exam-session-details.html",
                controller: "InternalExamSessionDetails",
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.prerequisites", {
                url: "/exams/sessions/details/:examSessionID/prerequisites",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-session-details/exam-session-details.html",
                controller: "InternalExamSessionDetails",
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.candidates", {
                url: "/exams/sessions/details/:examSessionID/candidates",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-session-details/exam-session-details.html",
                controller: "InternalExamSessionDetails",
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.evaluations", {
                url: "/exams/sessions/details/:examSessionID/evaluations",
                templateUrl: paths.app + "exams/components/exam-sessions/exam-session-details/exam-session-details.html",
                controller: "InternalExamSessionDetails",
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.details").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.results", {
                url: "/exams/sessions/results/:examSessionID",
                templateUrl: paths.app + "exams/components/exam-sessions-results/exam-sessions-results.html",
                controller: "InternalExamResults",
                params: {
                    examSessionID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.results").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.correspondences", {
                url: "/exams/sessions/:examSessionID/correspondences",
                templateUrl: paths.app + "exams/components/exam-sessions-correspondences/exam-sessions-correspondences.html",
                controller: "InternalExamSessionCorrespondences",
                params: {
                    examSessionID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.correspondences").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.correspondence", {
                url: "/exams/sessions/:examSessionID/correspondences/:correspondenceID",
                templateUrl: paths.app + "exams/components/exam-sessions-correspondence/exam-sessions-correspondence.html",
                controller: "InternalExamSessionCorrespondence",
                params: {
                    correspondenceID: null,
                    examSessionID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.correspondenceID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.correspondences").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.documents", {
                url: "/exams/sessions/:examSessionID/documents",
                templateUrl: paths.app + "exams/components/exam-sessions-documents/exam-sessions-documents.html",
                controller: "InternalExamSessionDocuments",
                params: {
                    examSessionID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.documents").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.session.document", {
                url: "/exams/sessions/:examSessionID/documents/:documentID/:candidateID",
                templateUrl: paths.app + "exams/components/exam-sessions-document/exam-sessions-document.html",
                controller: "InternalExamSessionDocument",
                params: {
                    documentID: null,
                    examSessionID: null,
                    candidateID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.documentID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.session.documents").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            })

            // Exam Configuration Tab 
            .state("internal.exams.administrative", {
                abstract: true,
                templateUrl: paths.app + "exams/layouts/administrative.html"
            }).state("internal.exams.administrative.skills", {
                url: "/exams/resource/skills",
                templateUrl: paths.app + "exams/components/exam-skills/exam-skills.html",
                controller: "InternalExamSkills",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.skills").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.skill", {
                url: "/exams/resource/skill/:examSkillID",
                templateUrl: paths.app + "exams/components/exam-skill/exam-skill.html",
                controller: "InternalExamSkill",
                params: {
                    examSkillID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSkillID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.skills').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.skillcategories", {
                url: "/exams/table/skillcategories",
                templateUrl: paths.app + "exams/components/exam-skill-categories/exam-skill-categories.html",
                controller: "InternalExamSkillCategories",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.skillcategories").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.skillcategory", {
                url: "/exams/table/skillcategory/:examSkillCategoryID",
                templateUrl: paths.app + "exams/components/exam-skill-category/exam-skill-category.html",
                controller: "InternalExamSkillCategory",
                params: {
                    examSkillCategoryID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSkillCategoryID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.skillcategories').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.forms", {
                url: "/exams/resource/forms",
                templateUrl: paths.app + "exams/components/exam-forms/exam-forms.html",
                controller: "InternalExamForms",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.exams.administrative.forms').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.form", {
                abstract: true,
                templateUrl: paths.app + "exams/components/exam-form/exam-form.html",
                controller: "InternalExamFormInfo",
                params: {
                    id: null,
                    examFormInfo: null,
                    saveMessage: null
                }
            }).state("internal.exams.administrative.form.details", {
                url: "/exams/resource/form/:id",
                templateUrl: paths.app + "exams/components/exam-form-detail/exam-form-detail.html",
                controller: "InternalExamFormDetails",
                params: {
                    id: null,
                    examFormInfo: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.forms').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.form.builder", {
                url: "/exams/resource/form/:id/builder/:formID",
                templateUrl: paths.app + "exams/components/exam-form-builder/exam-form-builder.html",
                controller: "InternalExamFormBuilder",
                params: {
                    id: null,
                    examFormInfo: null,
                    formID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.forms').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.form.preview", {
                url: "/exams/resource/form/:id/preview/:formID",
                templateUrl: paths.app + "exams/components/exam-form-preview/exam-form-preview.html",
                controller: "InternalExamFormPreview",
                params: {
                    id: null,
                    examFormInfo: null,
                    formID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.forms').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.packets", {
                url: "/exams/resource/packets",
                templateUrl: paths.app + "exams/components/exam-packets/exam-packets.html",
                controller: "InternalExamPackets",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.exams.administrative.packets').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.packet", {
                url: "/exams/resource/packet/:id",
                templateUrl: paths.app + "exams/components/exam-packet/exam-packet.html",
                controller: "InternalExamPacket",
                params: {
                    id: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.id == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.packets').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            })

            // Exam Automation 
            .state("internal.exams.administrative.autonumbers", {
                url: "/exams/table/autonumbers",
                templateUrl: paths.app + "exams/components/exam-auto-numbers/exam-auto-numbers.html",
                controller: "InternalExamAutoNumbers",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.autonumbers").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.autonumber", {
                url: "/exams/table/autonumber/:examAutoNumID",
                templateUrl: paths.app + "exams/components/exam-auto-number/exam-auto-number.html",
                controller: "InternalExamAutoNumber",
                params: {
                    examAutoNumID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examAutoNumID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.autonumbers').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.alerttypes", {
                url: "/exams/automation/alerttypes",
                templateUrl: paths.app + "exams/components/exam-automation-alert-types/exam-automation-alert-types.html",
                controller: "InternalExamAutomationAlertTypes",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.alerttype", {
                url: "/exams/automation/alerttype/:examAlertTypeID",
                templateUrl: paths.app + "exams/components/exam-automation-alert-type/exam-automation-alert-type.html",
                controller: "InternalExamAutomationAlertType",
                params: {
                    examAlertTypeID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examAlertTypeID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.alerttypes').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.correspondences", {
                url: "/exams/automation/correspondences",
                templateUrl: paths.app + "exams/components/exam-automation-correspondences/exam-automation-correspondences.html",
                controller: "InternalExamAutomationCorrespondences",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.correspondences").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.correspondence", {
                url: "/exams/automation/correspondence/:examTemplateID",
                templateUrl: paths.app + "exams/components/exam-automation-correspondence/exam-automation-correspondence.html",
                controller: "InternalExamAutomationCorrespondence",
                params: {
                    examTemplateID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examTemplateID == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.administrative.correspondences").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.sessionstatuses", {
                url: "/exams/table/sessionstatuses",
                templateUrl: paths.app + "exams/components/exam-session-statuses/exam-session-statuses.html",
                controller: "InternalExamSessionStatuses",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.sessionstatuses").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.sessionstatus", {
                url: "/exams/table/sessionstatus/:examSessionStatusID",
                templateUrl: paths.app + "exams/components/exam-session-status/exam-session-status.html",
                controller: "InternalExamSessionStatus",
                params: {
                    examSessionStatusID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examSessionStatusID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.sessionstatuses').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.types", {
                url: "/exams/table/types",
                templateUrl: paths.app + "exams/components/exam-types/exam-types.html",
                controller: "InternalExamTypes",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.types").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.type", {
                url: "/exams/table/type/:examTypeID",
                templateUrl: paths.app + "exams/components/exam-type/exam-type.html",
                controller: "InternalExamType",
                params: {
                    examTypeID: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examTypeID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.types').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.typetrigger", {
                url: "exams/table/typetrigger/:id/:triggerObjectID",
                templateUrl: paths.app + "exams/components/exam-typetrigger/exam-typetrigger.html",
                controller: "InternalExamTypeTrigger",
                params: {
                    id: null,
                    triggerObjectID: null,
                    trigger: null,
                    examTypeID: null,
                    configID: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.exams.administrative.types').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            })

            // Exam Permissions 
            .state("internal.exams.administrative.internalviews", {
                url: "/exams/permission/internalviews",
                templateUrl: paths.app + "exams/components/exam-internal-views/exam-internal-views.html",
                controller: "InternalExamViews",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.internalview", {
                abstract: true,
                templateUrl: paths.app + "exams/components/exam-internal-view/exam-internal-view.html",
                controller: "InternalExamView",
                params: {
                    queryId: null,
                    query: null
                }
            }).state("internal.exams.administrative.internalview.details", {
                url: "/exams/resource/internalview/:queryId",
                templateUrl: paths.app + "exams/components/exam-internal-view-details/exam-internal-view-details.html",
                controller: "InternalExamViewsDetails",
                params: {
                    queryId: null,
                    query: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.queryId == null) {
                            method = "add";
                        }
                        return Permissions[method]("internal.exams.administrative.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.internalview.criteria", {
                url: "/exams/resource/internalview/:queryId",
                templateUrl: paths.app + "exams/components/exam-internal-view-criteria/exam-internal-view-criteria.html",
                controller: "InternalExamViewsCriteria",
                params: {
                    queryId: null,
                    query: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.internalview.permission", {
                url: "/exams/resource/internalview/:queryId",
                templateUrl: paths.app + "exams/components/exam-internal-view-permission/exam-internal-view-permission.html",
                controller: "InternalExamViewsPermission",
                params: {
                    queryId: null,
                    query: null,
                    saveMessage: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.internalview.preview", {
                url: "/exams/resource/internalview/:queryId",
                templateUrl: paths.app + "exams/components/exam-internal-view-preview/exam-internal-view-preview.html",
                controller: "InternalExamViewsPreview",
                params: {
                    queryId: null,
                    query: null
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.internalviews").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            })



            .state("internal.exams.administrative.publiclookup", {
                url: "/exams/permission/publiclookup",
                templateUrl: paths.app + "exams/components/exam-public-lookup/exam-public-lookup.html",
                controller: "InternalExamPublicLookup",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.publiclookup").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.locations", {
                url: "/exams/permission/locations",
                templateUrl: paths.app + "exams/components/exam-permission-locations/exam-permission-locations.html",
                controller: "InternalExamPermissionLocations",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.locations").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.location", {
                url: "/exams/permission/location/:examLocationID",
                templateUrl: paths.app + "exams/components/exam-permission-location/exam-permission-location.html",
                controller: "InternalExamPermissionLocation",
                params: {
                    examLocationID: null,
                    copyLocation: null,
                    saveMessage: null,
                },
                resolve: {
                    permission: ["$state", "$stateParams", "$rootScope", "Permissions", function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        var method = "view";
                        if ($stateParams.examLocationID == null) {
                            method = "add";
                        }
                        return Permissions[method]('internal.exams.administrative.locations').then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.coordinators", {
                url: "/exams/permission/coordinators",
                templateUrl: paths.app + "exams/components/exam-permission-coordinators/exam-permission-coordinators.html",
                controller: "InternalExamPermissionCoordinators",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.coordinators").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            }).state("internal.exams.administrative.examiners", {
                url: "/exams/permission/examiners",
                templateUrl: paths.app + "exams/components/exam-permission-examiners/exam-permission-examiners.html",
                controller: "InternalExamPermissionExaminers",
                resolve: {
                    permission: ["$state", "$rootScope", "Permissions", function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.exams.administrative.examiners").then(function (access) {
                            if (!access) {
                                $state.go("internal.exams.denied");
                            }
                        });
                    }]
                }
            });
    }]);